import { buildApiUrl, getAuthHeaders } from "@/config/api";

export type DealPersonaRole = "ANALYST" | "REVIEWER" | "VIEWER";

export interface PersonaAssignment {
  personaType: string;      // backend enum (e.g., "CORPORATE_SECRETARIAL")
  userId: string;
  role?: DealPersonaRole;   // defaults to ANALYST server-side if omitted
}

export interface PersonaAssignee {
  personaType: string;
  role: DealPersonaRole;
  user: { id: string; name: string; email: string } | null;
}

class DealPersonaService {
  async assign(dealId: string, assignments: PersonaAssignment[]): Promise<void> {
    const res = await fetch(buildApiUrl(`/deals/${dealId}/personas/assign`), {
      method: "POST",
      headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
      body: JSON.stringify({ assignments }),
    });
    if (!res.ok) throw new Error(`Assign personas failed: ${res.status} ${await res.text()}`);
  }

  async listAssignees(dealId: string): Promise<PersonaAssignee[]> {
    const res = await fetch(buildApiUrl(`/deals/${dealId}/personas/assignees`), {
      method: "GET",
      headers: getAuthHeaders(),
    });
    if (!res.ok) throw new Error(`Fetch persona assignees failed: ${res.status} ${await res.text()}`);
    const json = await res.json();
    return json.personas ?? json.data ?? [];
  }
}

export const dealPersonaService = new DealPersonaService();
export default dealPersonaService;
